var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdamBenedictHeaderbackgroundHd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid slice",
    width: 3862,
    height: 503,
    viewBox: "0 0 3862 503",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11855_12839)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3862,
    height: 503,
    fill: "url(#paint0_linear_11855_12839)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3862,
    height: 503,
    fill: "url(#paint1_linear_11855_12839)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.679 648.235C626.708 342.899 1208.27 123.838 1651.95 107.478C2163.25 88.664 2367.9 343.625 2753.19 245.669C3104.79 156.366 3113.97 -101.752 3373.06 -154.178C3611.17 -202.351 3997.72 -64.1762 4658.17 676.92",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4629.91 712.383C3977.57 -17.936 3590.53 -162.107 3348.71 -120.673C3169.49 -89.7872 3105.71 38.2545 2969.13 142.297C2901.03 195.754 2816.13 236.545 2722.06 261.008C2413.92 341.316 2221.78 203.434 1886.42 155.82C1800.93 143.498 1713.43 138.53 1625.71 141.017C1180 152.602 603.857 345.772 549.208 640.504",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4601.58 747.745C3957.35 28.2567 3570.03 -121.868 3325 -87.1441C3144.88 -61.6077 3076.71 60.6683 2939.62 159.763C2869.75 211.489 2784.94 251.353 2691.65 276.317C2388.04 357.517 2196.64 234.15 1860.25 189.514C1774.76 178.041 1687.59 173.036 1600.12 174.58C1152.35 182.386 581.651 348.616 517.382 632.744",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4573.31 783.001C3937.34 74.4929 3549.54 -81.524 3301 -53.6528C3119.85 -33.3551 3047.57 83.0375 2909.74 177.246C2838.26 227.206 2753.6 266.161 2661.16 291.629C2361.81 373.735 2171.79 264.802 1834.02 223.212C1748.48 212.452 1661.53 207.361 1574.24 208C1124.46 211.449 559.223 351.315 485.334 624.839",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4545.05 818.517C3917.18 120.682 3529.18 -41.1353 3276.93 -20.1074C3094.96 -5.00596 3018.21 105.52 2879.71 194.682C2806.57 242.902 2721.91 280.994 2630.17 306.964C2335.06 389.974 2146.21 295.538 1806.91 256.948C1721.5 247.038 1634.97 241.921 1548.07 241.641C1096.2 240.737 536.441 354.29 452.86 617.214",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4517.08 853.914C3897.1 166.867 3508.39 -5.80407 3252.86 13.3844C3070.46 26.9356 2988.84 127.635 2849.84 212.162C2775.06 258.562 2690.4 295.787 2599.4 322.287C2308.54 406.203 2121 326.255 1780.68 290.695C1695.33 281.5 1609.09 276.308 1522.48 275.15C1068.52 269.683 514.237 357.081 421.038 609.452",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4488.46 889.343C3876.94 213.109 3488.51 40.0078 3228.85 46.6147C3045.49 51.9404 2959.33 150.073 2819.89 229.701C2743.56 274.26 2658.9 310.639 2568.63 337.665C2282.02 422.486 2095.57 356.986 1754.15 324.459C1668.86 316.042 1582.9 310.809 1496.6 308.78C1040.56 298.959 491.736 359.835 388.924 601.76",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4460.2 924.752C3857.01 259.287 3468.23 80.2867 3204.8 80.4191C3020.76 80.3331 2929.66 172.044 2789.95 247.131C2712.13 289.808 2627.42 325.326 2537.86 352.83C2255.56 438.606 2070.22 387.657 1727.63 358.01C1647.91 351.178 1562.87 345.008 1470.72 342.144C1012.51 327.817 469.25 362.743 356.813 593.959",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4431.94 960.166C3836.71 305.536 3447.98 121.144 3180.8 113.806C2996.03 108.782 2899.92 194.075 2759.85 264.52C2680.54 305.294 2595.74 340.018 2506.87 368.114C2228.82 454.795 2044.71 418.235 1700.88 391.731C1620.84 385.542 1536.01 379.467 1444.55 375.683C984.832 356.871 446.755 365.602 324.695 586.162",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4403.6 995.526C3816.56 351.724 3427.72 161.893 3156.74 147.455C2971.31 137.541 2869.82 216.223 2730.12 282.046C2649.43 320.89 2564.55 354.838 2476.39 383.528C2202.52 471.118 2019.58 449.054 1674.57 425.325C1594.55 419.763 1509.65 413.691 1418.87 409.038C956.553 385.53 424.247 368.145 292.57 578.152",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4375.34 1030.94C3796.47 397.91 3407.46 202.749 3132.88 180.938C2946.8 166.187 2840.22 238.14 2700.32 299.577C2618.26 336.413 2533.24 369.568 2445.76 398.846C2176.21 487.338 1994.43 479.717 1648.2 459.29C1567.85 454.475 1483.17 448.341 1393.15 442.868C928.729 414.642 401.981 371.254 260.539 570.664",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4347.09 1066.35C3776.32 444.152 3387.07 243.612 3108.67 214.439C2921.86 194.906 2810.12 260.03 2670.3 317.066C2589.93 349.83 2507.62 382.943 2414.85 414.179C2149.54 503.524 1968.94 510.451 1621.53 493.007C1541 488.882 1456.46 482.688 1366.98 476.406C900.462 443.46 379.2 374.073 228.212 562.928",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4318.82 1101.76C3756.18 490.55 3367.18 284.555 3084.68 247.981C2897.14 223.614 2780 281.814 2640.35 334.551C2557.95 365.68 2475.38 397.968 2384.07 429.503C2123.02 519.91 1943.65 541.121 1595.01 526.717C1514.29 523.332 1429.82 517.084 1341.25 509.923C872.692 472.15 356.848 376.872 196.243 555.175",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4290.71 1137.17C3736.09 536.579 3346.5 325.587 3060.68 281.523C2872.42 252.478 2749.88 303.545 2610.41 352.088C2525.89 381.481 2443.14 412.992 2353.59 444.866C2096.71 536.025 1918.66 571.882 1568.49 560.531C1487.51 557.786 1403.25 551.475 1315.37 543.55C844.705 500.85 334.351 379.677 164.128 547.428",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4262.23 1172.53C3715.93 582.768 3326.33 366.699 3036.61 315.015C2847.55 281.245 2719.69 325.123 2580.53 369.517C2493.9 397.122 2410.83 427.968 2322.53 460.151C2070.04 552.209 1893.01 602.516 1541.96 594.188C1457.29 591.543 1373 585.762 1289.41 576.868C816.79 529.494 311.643 382.596 132.013 539.629",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4233.97 1207.95C3695.78 629.01 3305.58 407.684 3012.83 348.496C2822.98 310.052 2689.7 346.641 2550.51 387.006C2461.77 412.772 2378.52 442.945 2291.76 475.476C2043.44 568.443 1867.65 633.243 1515.58 627.892C1431.02 626.035 1346.88 620.24 1263.68 610.542C788.856 557.826 289.361 385.392 99.8141 531.678",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4205.71 1243.36C3675.69 675.195 3284.84 449.031 2988.54 381.998C2798.05 338.978 2659.28 368.071 2520.63 404.435C2429.77 428.308 2346.36 457.965 2261.06 490.797C2017.06 584.665 1842.36 663.912 1488.91 661.608C1404.46 660.47 1320.46 654.607 1237.65 644.071C761.016 586.518 266.869 388.249 67.7115 524.139",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4177.37 1278.77C3655.55 721.645 3264.67 490.197 2964.54 415.54C2773.04 367.856 2629.07 389.389 2490.75 421.916C2397.48 443.806 2314.12 472.938 2230.28 506.121C1990.53 600.79 1817.08 694.634 1462.38 695.37C1378.05 694.918 1294.18 688.986 1211.77 677.647C733.161 615.002 244.369 391.054 35.5939 516.392",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4149.11 1314.18C3635.75 767.61 3244.07 531.487 2940.49 449.244C2748.12 396.992 2598.94 410.86 2460.82 439.715C2365.65 459.756 2281.75 488.284 2199.53 521.76C1964.02 617.439 1791.74 725.674 1435.87 729.289C1351.66 729.524 1267.9 723.523 1185.9 711.38C705.318 643.592 221.531 394.242 3.4929 508.856",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4120.86 1349.59C3615.31 813.864 3223.41 572.78 2916.49 482.576C2723.11 425.713 2568.8 431.808 2430.86 456.886C2333.56 474.616 2249.58 502.991 2168.75 536.874C1937.57 633.456 1766.45 756.135 1409.34 762.894C1325.26 763.842 1241.6 757.77 1160.02 744.798C677.527 671.707 199.387 396.717 -28.626 500.899",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4092.52 1384.96C3595.15 860.054 3202.75 614.335 2892.7 516.057C2698.4 454.683 2539.01 452.897 2401.27 474.355C2301.84 489.828 2217.63 517.951 2138.33 552.026C1911.32 649.569 1741.37 786.744 1383.1 796.487C1299.13 798.095 1215.53 791.952 1134.35 778.208C650.289 699.379 177.181 399.562 -60.5996 493.095",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4064.33 1420.37C3270.42 585.971 2729.73 445.142 2371.04 491.853C1979.48 542.837 1841.47 812.952 1356.29 830.262C787.122 850.511 196.318 388.327 -92.8585 485.354",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11855_12839",
    x1: -0.0000182433,
    y1: 13.9722,
    x2: 714.304,
    y2: 1771.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345201,
    stopColor: "#191A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F606D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11855_12839",
    x1: -0.0000182433,
    y1: 13.9722,
    x2: 714.304,
    y2: 1771.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345201,
    stopColor: "#191A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F606D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11855_12839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3862,
    height: 503,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdamBenedictHeaderbackgroundHd);
export default __webpack_public_path__ + "static/media/Adam Benedict Header background HD.10b0a0fc134b3ea217754345c5666b81.svg";
export { ForwardRef as ReactComponent };